import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/svg/checked.svg'


const _hoisted_1 = { class: "bg-gray-200 h-full" }
const _hoisted_2 = { class: "flex flex-col mx-6 pt-12 sm:pt-0" }
const _hoisted_3 = { class: "flex flex-row pt-4" }
const _hoisted_4 = { class: "h-12 inline-flex items-center p-4 ml-2" }
const _hoisted_5 = { class: "flex flex-row text-sm place-items-center my-2 ml-24" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-full p-2 bg-green-highlight w-8 h-8 mr-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-4 h-4",
    alt: "selected",
    src: _imports_0
  })
], -1 /* HOISTED */)
const _hoisted_7 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-4 border border-gray-400 rounded-md max-h-80 overflow-y-auto" }
const _hoisted_8 = {
  key: 0,
  class: "m-2"
}
const _hoisted_9 = {
  key: 1,
  class: "m-2"
}
const _hoisted_10 = ["id", "onClick"]
const _hoisted_11 = { class: "flex justify-center h-10 font-semibold text-lg" }
const _hoisted_12 = { class: "flex flex-row justify-center py-1" }
const _hoisted_13 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_14 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mt-4 border border-gray-400 rounded-md max-h-48 overflow-y-auto"
}
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "flex justify-center h-10 font-semibold text-lg" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-row justify-center py-1"
}
const _hoisted_18 = { class: "flex flex-row justify-center px-8 pb-8 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_ItemSelection = _resolveComponent("ItemSelection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          childclass: 'w-12',
          backgroundcolour: 'bg-red-button',
          logo: "leftArrow",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t('selectPlayers')), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", null, _toDisplayString(_ctx.t('checkedPlayersMeans')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.playerList.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.t('noPlayersInGame')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_ctx.otherPlayers.length === 0 && _ctx.playerList.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.t('noPlayersForUser')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerList, (p) => {
          return (_openBlock(), _createBlock(_component_ItemSelection, {
            key: p._id,
            class: "w-48 m-2",
            corners: true,
            selected: p.selected,
            colour: p.profile.avatar.backgroundColour
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                id: `div-togglePlayer-${p.profile.name}`,
                class: "cursor-pointer flex flex-col h-full",
                onClick: ($event: any) => (_ctx.togglePlayerActive(p))
              }, [
                _createVNode(_component_Avatar, {
                  layout: p.profile.avatar,
                  class: "w-48 h-48"
                }, null, 8 /* PROPS */, ["layout"]),
                _createElementVNode("p", _hoisted_11, _toDisplayString(p.profile.name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.user.status.canEditGames)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        id: "button-monitor",
                        childclass: 'w-32',
                        backgroundcolour: 'bg-white',
                        textcolour: 'text-black',
                        onVclick: ($event: any) => (_ctx.removePlayer(p))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('remove')), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onVclick"]))
                    : _createCommentVNode("v-if", true)
                ])
              ], 8 /* PROPS */, _hoisted_10)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["selected", "colour"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      (_ctx.otherPlayers.length > 0 && _ctx.user.status.canEditGames)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.t('otherPlayersAvailable') + ' ' + (_ctx.user.status.canEditGames ? _ctx.t('available') : _ctx.t('notAvailable'))), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_ctx.otherPlayers.length > 0 && _ctx.user.status.canEditGames)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherPlayers, (p) => {
              return (_openBlock(), _createElementBlock("div", {
                id: `div-togglePlayer-${p.profile.name}`,
                key: p._id,
                class: "w-48 m-2 cursor-pointer flex flex-col items-center rounded-xl bg-white",
                style: _normalizeStyle({ backgroundColor: p.profile.avatar.backgroundColour })
              }, [
                _createVNode(_component_Avatar, {
                  layout: p.profile.avatar,
                  class: "w-24 h-24"
                }, null, 8 /* PROPS */, ["layout"]),
                _createElementVNode("p", _hoisted_16, _toDisplayString(p.profile.name), 1 /* TEXT */),
                (_ctx.g.players.length < 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_ctx.user.status.canEditGames)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            id: "button-monitor",
                            childclass: 'w-32',
                            backgroundcolour: 'bg-white',
                            textcolour: 'text-black',
                            onVclick: ($event: any) => (_ctx.addPlayer(p))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('add')), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onVclick"]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 12 /* STYLE, PROPS */, _hoisted_15))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_18, [
        _withDirectives(_createVNode(_component_Button, {
          id: "button-done",
          class: "self-end mr-4",
          childclass: 'w-32',
          backgroundcolour: 'bg-blue-button',
          textcolour: 'text-black',
          onVclick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.done()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('begin')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.beginActive]
        ])
      ])
    ])
  ]))
}